export default __webpack_public_path__ + "images/0x6aa38edd7f32a28b7b2c2dc86fc5b0bf2ae61579.png";